    export const validMimeTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/zip",
      "text/plain",
      "text/csv",
      "application/json",
    ];

    export const validImageTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/bmp"];